import React from 'react';

/**
 * Section - Donation Section
 * Displays donation call-to-action
 */
export function DonationSection({ backgroundColor }) {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center w-full relative px-4 sm:px-8 md:px-16 lg:px-24"
      style={{
        scrollSnapAlign: 'start',
        scrollSnapStop: 'always',
      }}
    >
      <div className="max-w-4xl w-full text-center bg-gradient-to-br from-blue-500/40 via-purple-500/30 to-pink-500/40 backdrop-blur-xl rounded-2xl sm:rounded-3xl p-5 sm:p-10 md:p-16">
        {/* Section Heading */}
        <h2 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-8">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-pink-500">Gefällt dir,</span><br />
          <span className="text-white">was du hörst?</span>
        </h2>

        {/* Description */}
        <p className="text-sm sm:text-lg md:text-xl text-white/80 leading-relaxed mb-2 sm:mb-3 max-w-2xl mx-auto">
          Unser Projekt wird <span className="text-white font-semibold">privat finanziert</span>.
        </p>
        <p className="text-sm sm:text-lg md:text-xl text-white/80 leading-relaxed mb-6 sm:mb-10 max-w-2xl mx-auto">
          Deine Spende hilft uns, <span className="text-white font-semibold">neue Features</span> zu entwickeln und den Betrieb aufrechtzuerhalten.
        </p>

        {/* Donate Button */}
        <a
          href="https://www.paypal.com/donate/?hosted_button_id=7RMXCB5VSNL9U"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-6 sm:px-10 py-3 sm:py-4 bg-gradient-to-r from-blue-500 to-pink-500 text-white font-semibold text-sm sm:text-lg rounded-full hover:opacity-90 transition-all shadow-lg"
        >
          Jetzt unterstützen
        </a>

        {/* Thank you */}
        <p className="text-sm sm:text-base text-white/60 mt-6 sm:mt-8">
          Schmalsten Dank! 🙂
        </p>
      </div>
    </div>
  );
}
